import TreeList, { Column, Editing, Texts, Button, Scrolling } from "devextreme-react/tree-list";
import { useHistory } from "react-router-dom";
import { fetchDocumentTemplates } from "../../../../actions/documentTemplateActions";
import { Routes } from "../../../../AppRoutes";
import { CreateNotification } from "../../../../components/notifier";
import { DocumentTemplateService } from "../../../../services/document/document-template.service";
import { Spin, Button as AntButton } from "antd";
import { Box } from "../../../../components";
import { useDocumentTemplate } from "../../hooks";

export const DocumentTemplate = () => {
  const { data, isLoading } = useDocumentTemplate();
  const history = useHistory();

  const updateRow = async (e: any) => {
    try {
      const fields = { ...e.newData };

      await DocumentTemplateService.update(e.oldData.Id, fields);
      fetchDocumentTemplates();
    } catch (error: any) {
      CreateNotification({ title: "Không cập nhật", body: error.message, icon: "/icons/error.png" });
      console.log(error);
    }
  };

  const newRow = async (e: any) => {
    try {
      const result = await DocumentTemplateService.create({
        Title: e.data.Title,
        IsActive: e.data.IsActive ? e.data.IsActive : true,
        // eslint-disable-next-line eqeqeq
        CategoryLookupId: e.data.CategoryLookupId == 0 ? null : e.data.CategoryLookupId,
      });

      e.data.Id = result.Id;
      fetchDocumentTemplates();
    } catch (error: any) {
      CreateNotification({ title: "Không thêm mới", body: error.message, icon: "/icons/error.png" });
      console.log(error);
    }
  };

  const deleteRow = async (e: any) => {
    try {
      await DocumentTemplateService.delete(e.data.Id);
      fetchDocumentTemplates();
    } catch (error: any) {
      CreateNotification({ title: "Không thêm mới", body: error.message, icon: "/icons/error.png" });
      console.log(error);
    }
  };

  const initNewRow = async (e: any) => {
    e.data.IsAcitve = true;
  };

  const titleClick = (cellInfo: any) => {
    if (!cellInfo.data.CategoryLookupId) return;

    history.push(Routes.documentTemplate.path.replace(":id", `${cellInfo.data.Id}`));
  };

  const renderTitleCell = (cellInfo: any) => {
    return cellInfo?.data?.CategoryLookupId ? (
      <AntButton
        onClick={(e) => {
          titleClick(cellInfo);
        }}
        type="link"
      >
        {cellInfo.value}
      </AntButton>
    ) : (
      <span>{cellInfo.value}</span>
    );
  };

  if (isLoading) return <Spin />;

  return (
    <Box title="Danh sách templates">
      <TreeList
        width="80%"
        id="content"
        dataSource={data}
        showRowLines={true}
        showBorders={true}
        autoExpandAll={true}
        columnAutoWidth={true}
        keyExpr="Id"
        parentIdExpr="CategoryLookupId"
        onInitNewRow={initNewRow}
        onRowUpdating={updateRow}
        onRowInserted={newRow}
        onRowRemoved={deleteRow}
      >
        <Editing allowUpdating={true} allowDeleting={true} allowAdding={true} mode="form">
          <Texts
            confirmDeleteMessage="Bạn có muốn xóa mẫu này không?"
            cancelRowChanges="Thoát"
            saveRowChanges="Lưu"
            deleteRow="Remove"
          />
        </Editing>
        <Scrolling mode="standard" />
        <Column caption="Tên" dataField="Title" dataType="string" cellRender={renderTitleCell} />
        <Column caption="Hiện/Ẩn" dataField="IsActive" dataType="boolean" />
        <Column type="buttons">
          <Button text="Thêm" name="add" />
          <Button text="Sửa" name="edit" />
          <Button text="Xóa" name="delete" />
        </Column>
      </TreeList>
      {/*  <WarningDeleteModal data={deletedItem} title={deletedTitle} message={deletedMessge} isOpen={showDeletedConfirm} onDelete={handleDeletedConfirm} onClose={handleCloseDeletedConfirm} /> */}
    </Box>
  );
};
